"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getDefaultRoutes = appConfig => {
  const _ref = appConfig || {},
        pages = _ref.pages;

  const _ref2 = pages || {},
        _ref2$PageNotFound = _ref2.PageNotFound,
        PageNotFound = _ref2$PageNotFound === void 0 ? () => /*#__PURE__*/_react.default.createElement("div", null, "Page not found") : _ref2$PageNotFound;

  return [/*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    component: PageNotFound
  })];
};

var _default = getDefaultRoutes;
exports.default = _default;
module.exports = exports.default;